/* Here not to persist attributes with the note */
var Backbone = require('backbone');

module.exports = Backbone.Model.extend({

    defaults: {

        /* set on init */
        raphaelEl:              null,
        isActive:               false, // (active, not selected ) is the parent note of the shape the active note in the viewer/canvas
        isSelected:             false, // (active && selected)

        isMoving:               false,
        isResizing:             false,
        isExpanded:             false,
        isHighlighted:          false,
        isParentNoteDrawing:    false,
        isNewlyDrawn:           false, // flag set to true if model created from addNewlyDrawnShape: if renderedFromModel will remain false; basically implies was the shape just drawn / not

        // Find and redact only -- need to subclass but larger project
        isMouseOverFindAndRedactHitView: false,
        isHitApplied: false,
        isDirty: false // if the user moved/resize the shape so it's position is different than the original of the hit

    },

    // DVBC-1762: called on central shape removal --
    // In current WF, some notes ( now only FPR ) are persisted on the note model
    // in between canvas render/re-render -- this is a quick fix to make sure they are
    // always set back to not active or expanded but default before re-rendering the shapes
    // and handling active/expanded notes.
    // Longer term approach ( if use for other shape types ) could involve always resetting,
    // the shape models on the note when they are toggled active/expanded.
    resetActiveAndExpandedState: function() {

        this.set({
            isActive: false,
            isExpanded: false
        }, {
            silent: true
        });

    },

    getCursor: function() {
        return this.get('raphaelEl').attr('cursor');
    },
    setExpanded: function() {
        this.set({
            isExpanded: true,
            isHighlighted: false
        });
    },
    // Shouldn't need anymore -- re-rendering canvas
    unsetExpanded: function() {
        this.set({
            isExpanded: false,
            isHighlighted: false
        });
    },
    unSelect: function() {
        this.set({ isSelected: false });
    },
    select: function() {
        this.set({ isSelected: true });
    },
    highlight: function() {
        this.set({ isHighlighted: true });
    },
    unhighlight: function() {
        this.set({ isHighlighted: false });
    },
    activate: function() {
        this.set({
            isActive: true,
            isHighlighted: false
        }, {isEntering: true} );
    },
    deactivate: function() {
        this.set({
            isActive: false,
            isHighlighted: false
        }, {isEntering: false} );
    },
    raphaelEl: function() {
        return this.get('raphaelEl');
    },
    getBBoxOfEl: function() {
      return this.get('raphaelEl').getBBox();
    },
    getRaphaelElPaper: function() {
        var rEl = this.raphaelEl();
        return !rEl
            ? null
            : rEl.paper;
    },


    destroy: function() {
        this.get('raphaelEl').remove();
        this.set('raphaelEl', null);
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/shapeUI.js
 ** module id = 255
 ** module chunks = 0
 **/